import styled from 'styled-components'
import { MdKeyboardArrowDown, MdArrowDownward } from 'react-icons/md'

export const HeroContainer = styled.div`
  background: #0c0c0c;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  height: 110vh;
  position: relative;
  z-index: 1;
  overflow-x: hidden;
`

export const HeroBg = styled.img`
  background-repeat: no-repeat;
  width: 100%;
  height: 100%;
  overflow: hidden;
  filter: brightness(50%);
`

export const HeroLogo = styled.img`
    @media screen and (max-width: 800px) {
      transform: scale(0.7);
  }

  @media screen and (max-width: 480px) {
    transform: scale(0.5);
  }
`

export const HeroContent = styled.div`
  z-index: 3;
  max-width: 1200px;
  position: absolute;
  padding: 8px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
`
export const HeroP = styled.p`
  margin-top: 24px;
  color: #fff;
  font-size: 2rem;
  text-align: center;
  max-width: 800px;

  @media screen and (max-width: 800px) {
    font-size: 1.5rem;
    max-width: 600px;
    margin-top: 0;
  }

  @media screen and (max-width: 480px) {
    font-size: .8rem;
    max-width: 360px;
  }
`

export const HeroBtnWrapper = styled.div`
  margin-top: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const ArrowDown = styled(MdArrowDownward)`
  margin-left: 8px;
  font-size: 20px;
`
export const ArrowDownFull = styled(MdKeyboardArrowDown)`
  margin-left: 8px;
  font-size: 20px;
`
